import { SubNavigationEntry } from '@common/types/sub-navigation-entry';
import { noop } from 'lodash';
import { createContext, useContext } from 'react';

export type SubNavigationContextType = {
  entries: SubNavigationEntry[];
  overwriteRules: boolean;
  setEntries: (entries: SubNavigationEntry[]) => void;
  setOverwriteRules: (overwrite: boolean) => void;
  hide: boolean | null;
  setHide: (visible: boolean | null) => void;
};

export const SubNavigationContext = createContext<SubNavigationContextType>({
  entries: [],
  hide: false,
  overwriteRules: false,
  setEntries: noop,
  setOverwriteRules: noop,
  setHide: noop,
});

export const useSubNavigationContext = () => useContext(SubNavigationContext);
